import { memo, type MouseEvent } from "react";

import { Button } from "@components/Button";
import { Icon } from "@components/Icon";
import { Text } from "@components/Text";
import { tw } from "classnames";

type Props = {
  buttonText: string;
  openGiftWithPurchaseDrawer: (e: MouseEvent<HTMLElement>) => void;
  title: string;
};

const styles = {
  container: tw(
    "px-6",
    "py-4",
    "flex",
    "flex-row",
    "items-center",
    "bg-primary-inverse",
    "border-0",
    "border-b",
    "border-solid",
    "border-char-200"
  ),
  giftIcon: tw("w-6", "h-6", "mr-2"),
  text: tw("flex-1"),
};

const CartSpendingGitWithPurchaseSelectionViewBase = ({
  buttonText,
  openGiftWithPurchaseDrawer,
  title,
}: Props) => {
  return (
    <div className={styles.container}>
      <Icon className={styles.giftIcon} name="gift" />
      <Text className={styles.text}>{title}</Text>
      <Button onClick={openGiftWithPurchaseDrawer} type="pill-outline">
        {buttonText}
      </Button>
    </div>
  );
};

export const CartSpendingGitWithPurchaseSelectionView = memo(
  CartSpendingGitWithPurchaseSelectionViewBase
);
